import { render } from "./SubmitFormList.vue?vue&type=template&id=0e7197b8"
import script from "./SubmitFormList.vue?vue&type=script&lang=js"
export * from "./SubmitFormList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__